import { writable, get } from 'svelte/store';

export let empty_user = {
    username: '',
    login_id: '',
    name: '',
    email: '',
    players: {},
    conventions: {},
    chat: {},
    pairs: [],
    partners: {},
    greetings: [['Hi <opps>', 'D'], ['Hi <opps>: <names>: <system>']],
    valedictions: [['Thank you', 'D']],
    my_name: '',
    last_partner: '',
}
export let user = writable(empty_user);

export let state = writable({
    mode: 'g',
    usernames: [],
    first_names: [],
    partner: {},
    system: '',
    message: '',
    alpha: 'All',
    new_item: '',
    partner: '',
});
